import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@progress/kendo-react-inputs';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';

function TextRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  return (
    <Input
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.value ?? '')}
      disabled={readOnly}
      maxLength={field.validation?.maxLength}
      placeholder={field.label}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'TXT',
  label: 'Text',
  category: 'input',
  icon: <FontAwesomeIcon icon={faFont} fixedWidth />,
  defaultProps: { label: 'New text field', isRequired: false },
  Renderer: TextRenderer,
};
